import { useCallback, useEffect, useRef } from "react"

const useMultiInputFocus = ({
  useEffectDelay = 0,
}: {
  useEffectDelay?: number
}) => {
  const ref = useRef<{
    focusFirstInput: (delay?: number) => void
    clearInputs: () => void
  }>(null)

  const focusFirstInput = useCallback(
    (delay?: number) => {
      ref.current?.focusFirstInput(delay)
    },
    [ref]
  )

  const clearInputs = useCallback(() => {
    ref.current?.clearInputs()
  }, [ref])

  useEffect(() => {
    focusFirstInput(useEffectDelay)
  }, [focusFirstInput, useEffectDelay])

  return {
    ref,
    focusFirstInput,
    clearInputs,
  }
}

export default useMultiInputFocus
